import React, {useState} from "react";
import Button from "../Button/Button";
import CreditsIcon from "../../assets/icons/credits-white.svg";
import CreditsIconBlack from "../../assets/icons/credits.svg";
import Popup from "../Popup/Popup";
import useFeedbackService from "../../api/services/useFeedbackService";
import Loading from "../Loading/Loading";
import swal from "sweetalert";
import PropTypes from "prop-types";


const FeedbackPopup = ({location, updateSuccess = null}) => {

  const [showFeedback, setShowFeedback] = useState(false)
  const [feedback, setFeedback] = useState('')
  const [errors, setErrors] = useState('')
  const feedbackService = useFeedbackService()
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = () => {
    setIsLoading(true)
    feedbackService.userStore(
      () => {
        setErrors(null)
        setFeedback('')
        setIsLoading(false)
        setShowFeedback(false)
        swal({
          title: 'Dank! ',
          icon: 'success',
          timer: 2000,
          buttons: false,
        })
        updateSuccess && updateSuccess()
      },
      (errors) => {
        setErrors(errors)
        setIsLoading(false)
      },
      {feedback: feedback, location: location}
    )
  }

  return (
    <div className="component-feedback-popup">
      <Button
        label="Feedback voor credits!"
        color="blue"
        size="xl"
        onClick={() => setShowFeedback(true)}
        icon={CreditsIcon}
      />
      {showFeedback &&
        <Popup
          title="Jouw feedback is geld waard!"
          showPopup={!!showFeedback}
          setShowPopup={setShowFeedback}
          closeButtonLabel="Annuleren"
          closeButtonClassName="btn-color-grey"
          postButtons={<Button
            label={'Verstuur feedback'}
            className="btn-color-blue"
            icon={CreditsIcon}
            disabled={isLoading}
            onClick={handleSubmit}
          />}
        >
          <div className="component-feedback-popup-content">
            <p>Verdien <img src={CreditsIconBlack} alt=""/><strong>20 Stand-credits</strong> door jouw feedback te geven.
              Jouw feedback is ons veel waard!
            </p>
            {isLoading
              ? <><Loading/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
              </>
              :
              <>
                {errors !== '' && errors !== null && <p className="color-red">{errors.feedback[0]}</p>
                }
                <textarea
                  placeholder="Wat mis je op deze pagina? Of heb je andere feedback? Jouw mening wordt erg gewaardeerd!"
                  name="feedback"
                  value={feedback}
                  rows="5"
                  onChange={(e) => setFeedback(e.target.value)}
                />
              </>
            }
          </div>
        </Popup>
      }
    </div>
  )
}

FeedbackPopup.propTypes = {
  location: PropTypes.string.isRequired,
  updateSuccess: PropTypes.func,
}

export default FeedbackPopup;